function format(id, value) {
  const size = value.length.toString().padStart(2, '0');
  return id + size + value;
}

function crc16(payload) {
  let polinomio = 0x1021;
  let resultado = 0xFFFF;

  for (let i = 0; i < payload.length; i++) {
    resultado ^= payload.charCodeAt(i) << 8;

    for (let j = 0; j < 8; j++) {
      if ((resultado <<= 1) & 0x10000) resultado ^= polinomio;
      resultado &= 0xFFFF;
    }
  }

  return resultado.toString(16).toUpperCase().padStart(4, '0');
}

export function gerarPayloadPix(key, nome, cidade, valor, txid) {
  const valorFormatado = Number(valor).toFixed(2);

  const payload =
    format('00', '01') + // Payload Format Indicator
    format('26',
      format('00', 'BR.GOV.BCB.PIX') +
      format('01', key)
    ) +
    format('52', '0000') + // MCC
    format('53', '986') + // BRL
    format('54', valorFormatado) +
    format('58', 'BR') +
    format('59', nome.substring(0, 25)) +
    format('60', cidade.substring(0, 15)) +
    format('62',
      format('05', txid.substring(0, 25))
    ) +
    '6304';

  const checksum = crc16(payload);

  return payload + checksum;
}